export default __webpack_public_path__ + "static/app-landing-page-183024cdf676359c7430b99882942f62.png";